module.exports = __webpack_public_path__ + "img/bank_icon11.e9523796.png";